import React from 'react'
import {
  Grid,  Typography, Box, Card, CardContent } from '@mui/material'
import {
  PublicPageLayout,
  getNextLevelLogoProps,
} from '@/housefolios-components/PublicPages/shared'

function PublicCitiesPage(props) {
  const { logoSrc, logoAlt } = getNextLevelLogoProps(props.marketplace)

  // Placeholder cities - will be replaced with actual data
  const cities = [
    {
      name: 'City 1',
      state: 'State',
      description:
        '[Placeholder: Description of why this city is a great investment opportunity, including market trends, growth potential, rental yields, etc.]'},
    {
      name: 'City 2',
      state: 'State',
      description:
        '[Placeholder: Description of why this city is a great investment opportunity, including market trends, growth potential, rental yields, etc.]'},
    {
      name: 'City 3',
      state: 'State',
      description:
        '[Placeholder: Description of why this city is a great investment opportunity, including market trends, growth potential, rental yields, etc.]'},
  ]

  return (
    <PublicPageLayout
      title={
        props.marketplace
          ? `${props.marketplace.name} Investment Cities`
          : 'Investment Cities'
      }
      description="Discover why we invest in these cities"
      icon={logoSrc ? undefined : null}
      logoSrc={logoSrc}
      logoAlt={logoAlt}
      containerProps={{
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: 5}}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1200,
          marginTop: 4}}
      >
        <Grid container spacing={4}>
          <Grid size={12}>
            <Typography variant="h4" component="h2" gutterBottom>
              Our Investment Cities
            </Typography>
            <Typography variant="body1" sx={{
              marginBottom: "16px"
            }}>
              [Content coming soon - This page will showcase the cities we invest
              in and explain why each city presents excellent investment
              opportunities.]
            </Typography>
          </Grid>

          {cities.map((city, index) => (
            <Grid size={{xs: 12, md: 6}} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'}}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h5" component="h3" gutterBottom>
                    {city.name}, {city.state}
                  </Typography>
                  <Typography variant="body1" sx={{
                    marginBottom: "16px"
                  }}>
                    {city.description}
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: "text.secondary"
                  }}>
                    [Placeholder: Additional details such as average property
                    prices, rental yields, population growth, job market
                    statistics, etc.]
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </PublicPageLayout>
  );
}

export default PublicCitiesPage
